<template>
  <van-popup v-model="show" class="wrap_popup">
    <img
      :class="$style.close"
      @click.stop="$emit('handlerShow')"
      src="@/assets/Images/close.png"
    />
    <div :class="$style.content">
      <div
        v-if="agreementHtml"
        :class="$style.agreement"
        v-html="agreementHtml"
      ></div>
      <iframe
        v-else
        :src="link"
        width="300"
        height="300"
        frameborder="0"
        scrolling="auto"
      ></iframe>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: "BaseAgreement",
  props: {
    agreementHtml: {
      type: String
    },
    link: {
      type: String
    },
    show: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="less" module>
iframe {
  .size(100%);
}
.content {
  .size(100%);
  background: #fff;
  position: relative;
  overflow-y: scroll;
}
.close {
  .size(0.8rem);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
}
.agreement {
  .size(auto, 100%);
  padding: 0.4rem;
  h3 {
    font-size: 0.3rem;
  }
  p,
  li {
    font-size: 0.28rem;
  }
}
</style>
